import { CurrentSeasonDTO } from "./dto/CurrentSeasonDTO";
import { NetworkService } from "./NetworkService";

interface ISeasonService {
  getCurrentSeason(): Promise<CurrentSeasonDTO>;
}

class SeasonService implements ISeasonService {
  getCurrentSeason(): Promise<CurrentSeasonDTO> {
    return NetworkService.shared.get<CurrentSeasonDTO>("/season/current");
  }
}

export const seasonService: ISeasonService = new SeasonService();
